const CONFIG = {
  basePathname: '/',

  dateFormatter: new Intl.DateTimeFormat('en', {
    day: 'numeric',
    month: 'short',
    timeZone: 'UTC',
    year: 'numeric',
  }),

  description:
    'content="IQF, Frozen, Ambient, Fresh and Dried food ingredient supplier to food manufacturers"',

  keywords:
    'frozen,IQF,vegetables,fruit,garlic,ginger,onions,chillies,exotics,tea,rice,legumes,ambient,fresh,diced,sliced,whole',

  language: 'en',
  name: 'North Star Foods Ltd',
  shortName: 'NorthStarFoods',

  origin: 'https://www.northstarfoodsltd.co.uk',

  textDirection: 'ltr',
  title: '',
  trailingSlash: false,
  email: 'info@northstarfoodsltd.co.uk',
  headOffice: '+44 (1858) 465000',
  worldwide: '+44 (1858) 465001',
  mobile: '+44 (7407) 650222',
  skype: 'Northstarfoodsltd',
  address: ``,
  mapsKey: 'AIzaSyCK_pYC_1hij6whN6eKm9gDvN4w4WlusHc',
  web3formKey: 'cc5f9388-10cd-4535-82e4-1f4c9d6bf20e',
} as const

export const SITE = { ...CONFIG }
export const DATE_FORMATTER = CONFIG.dateFormatter
